import { ChevronUp } from "lucide-react";
import { cn } from "@punchup/utils/cn";

interface Props {
  label?: string;
  onClick: () => void;
  className?: string;
}

export default function ShowLessButton({
  label = "Show Less",
  onClick,
  className,
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex flex-row items-center justify-center leading-tight gap-x-1 bg-transparent text-primary-blue text-base font-semibold transition-colors ease-in-out duration-200 hover:bg-neutral-100 px-5 py-3 rounded-md",
        className
      )}
    >
      <span>{label}</span>
      <ChevronUp width={24} height={24} />
    </button>
  );
}
